import { Paper, Typography } from "@mui/material"
import * as Styled from "./styled"

export default (message) => (
  <Typography>{message?.text}</Typography>

)
